module.exports = __webpack_public_path__ + "static/10xEvolve-ecb2b7ec2c4dc60f16b85959e8ac2a08.png";